<template>
  <div
    class="tab-pane fade"
    id="claim"
    role="tabpanel"
    aria-labelledby="claim-tab"
  >
    <!-- TBA -->
    <div class="card-body">
      <h4 class="card-title mb-3">TBA</h4>

      <p>The table below shows the list of TBA claims.</p>

      <div class="table-responsive">
        <table
          id="tbaclaim_tbl"
          class="display table table-striped table-bordered"
          style="width:100%; text-align: center;"
        >
          <thead>
            <tr>
              <th>No.</th>
              <th>Certificate No.</th>
              <th>Product</th>
              <th>Type</th>
              <th>Date submit to counter</th>
              <th>Notification Date</th>
              <th>Officer</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(claim, index) in tba_claim" v-bind:key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ claim.certificate.cert_no }}</td>
              <td>{{ claim.product.name }}</td>
              <td>{{ claim.benefit.name }}</td>
              <td>{{ claim.counter_date | moment("Do MMMM YYYY") }}</td>
              <td>
                {{ claim.created_at | moment("Do MMMM YYYY, h:mm:ss a") }}
              </td>
              <td>
                <span v-if="claim.staff != null">{{
                  claim.staff.user.name
                }}</span>
              </td>
              <td>
                <span v-if="claim.status.id === 10"
                  >Pending Document Submission</span
                ><span v-else>{{ claim.status.name }}</span>
              </td>
              <td>
                <router-link
                  :to="claimDetail(claim.id)"
                  type="button"
                  class="btn btn-success btn-rounded btn-block"
                  style="background-color: #78BE20; border-color: #78BE20;"
                  >View Details</router-link
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "customer_claim",
  components: {},

  data() {
    return {
      tba_claim: [
        {
          id: "",
          certificate: { cert_no: "" },
          product: { name: "" },
          benefit: { name: "" },
          counter_date: "",
          created_at: "",
          status: { name: "" },
          staff: {
            user: {
              name: ""
            }
          }
        }
      ]
    };
  },

  methods: {
    loadTBAclaim() {
      let token = localStorage.getItem("token");
      this.customer_id = this.$route.params.id;

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("/tba/claim/filter?customer=" + this.customer_id, {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.tba_claim = res.data;
          });
      }
    },

    claimDetail(id) {
      return "/tba/claim_details/" + id;
    }
  },

  mounted() {
    this.loadTBAclaim();

    setTimeout(function() {
      $("#tbaclaim_tbl").DataTable({
        dom: "Bfrtip",
        buttons: ["excel", "pdf"]
      });
    }, 1000);
  }
};
</script>
